
export const formatPaybackPeriod = (v) =>
  v == null ? "N/A" : String(v).trim() === "0" ? "No payback period" : String(v).trim();
